import {remCalc} from '../_utils'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    11: '2.75rem',

    container: {
        xs: remCalc(376),
        sm: remCalc(640),
        md: remCalc(768),
        lg: remCalc(1024),
        xl: remCalc(1200),
        xxl: remCalc(1512),
        xxxl: remCalc(1920),
    },
}
